<footer class="clr-footer">
  <div class="copyright-content-wrapper">
    <div>
      <p class="footer-content-paragraph">
        Copyright © 2005-2025 Broadcom. All Rights Reserved. The term “Broadcom” refers to Broadcom Inc. and/or its
        subsidiaries.<br />
        Code licensed by
        <a class="mit-link" href="https://opensource.org/licenses/MIT" target="_blank">MIT License</a>
        <a href="https://www.vmware.com/help/privacy.html" target="_blank">Privacy Policy</a>
      </p>
    </div>
    <div class="community-iconlist">
      <a class="community-icon" href="https://github.com/vmware-clarity" target="_blank">
        <img src="/assets/images/footer/github.svg" alt="Clarity Github" />
      </a>
      <a class="community-icon" href="https://medium.com/claritydesignsystem" target="_blank">
        <img src="/assets/images/footer/medium.svg" alt="Clarity Medium" />
      </a>
    </div>
  </div>
</footer>
